module.exports = __webpack_public_path__ + "images/emoji/clapper.e87d601d3509887a1da7.png";